import * as types from '@/store/mutationTypes';
import { UserPermissions } from '@/utils/userInfo';
import receiptsService from '@/http/services/receiptsService';

export const actions = {
    updatePaynowTransactionPageSize: async (context, pageSize) => {
        context.commit(types.SET_PAYNOW_TRANSACTION_PAGE_SIZE, pageSize);
    },

    getReceipts: async (context) => {

        let isNewPaymentFlow = context.getters.isNewPaymentFlowFeatureEnabled;
        if (isNewPaymentFlow) {          

            let paginationParams = {
                size: context.getters.pageSize,
                page: context.getters.pageNumber,
                searchText: context.getters.searchQuery,
                status: context.getters.modalFilters && context.getters.modalFilters.invoiceStatus,
            }

            const userInfo = UserPermissions.getUserInfoFromLocalStorage();
            const receipts = 
                await receiptsService.getInvoiceForNewPaymentFlow(context.getters.schoolInfo.id, userInfo.userId, mapPaginationParamsToQueryString(paginationParams)); 

            const { pageable, totalPages, totalElements, numberOfElements } = receipts;

            const content = {
                content: receipts.content.map((receipt) => {
                    return {
                        amount: receipt.status === 'paid'?  receipt.amountPaid : receipt.amountDue,
                        chargeId: receipt.id,
                        createdDate: receipt.date,
                        description: receipt.activityDetails.name,
                        childName:receipt.child.name,
                        refund: receipt.refundAmount,
                        status: receipt.status,
                        paymentUrl: receipt.paymentUrl
                    }
                })
            }

            context.commit(types.SET_RECEIPTS, content);
            window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    });

            context.dispatch('configPagination', {
                ...pageable,
                numberOfElements,
                totalElements,
                totalPages,
                callback: () => {
                    return context.dispatch('getReceipts');
                }
            });
            
        } else {
            const userInfo = UserPermissions.getUserInfoFromLocalStorage();
            const options = {
                size: context.getters.pageSize,
                page: context.getters.pageNumber,
                search: context.getters.searchQuery,
                sort: [ context.getters.sortBy || 'createdAt', context.getters.sortDirection || 'DESC' ],
            };

            const receipts = await receiptsService.getReceipts({ parentId: userInfo.userId, options });

            const { pageable, totalPages, totalElements, numberOfElements } = receipts;

            context.commit(types.SET_RECEIPTS, receipts);
    
            context.dispatch('configPagination', {
                ...pageable,
                numberOfElements,
                totalElements,
                totalPages,
                callback: () => {
                    return context.dispatch('getReceipts');
                }
            });

        }
    },
    getInitialNewPaymenFeature: async (context) => {
            await context.dispatch("getSchoolInfo");
            const isNewPaymentFlow = context.getters.schoolInfo && context.getters.schoolInfo.schoolFeatures && context.getters.schoolInfo.schoolFeatures["new-payments"];
            context.commit(types.SET_IS_NEW_PAYMENT_FLOW_FEATURE, {
                enabled: isNewPaymentFlow
            });
    },
    toggleOldReceipts: async (context) => {
        context.commit(types.SET_IS_NEW_PAYMENT_FLOW_FEATURE, { 
            enabled: !context.getters.isNewPaymentFlowFeatureEnabled
        });
    },

    downloadReceipt: async(context, payload) => {
        const userInfo = UserPermissions.getUserInfoFromLocalStorage();
        const options = { chargeId: payload };

        const url = await receiptsService.downloadReceipt({ parentId: userInfo.userId, options });
        window.open(url);
    }
};

/**
 * Converts pagination parameters object to a URL query string
 * @param {Object} paginationParams - The pagination parameters object
 * @returns {String} The formatted query string
 */
function mapPaginationParamsToQueryString(paginationParams) {
    // Create an array to hold the query parameters
    const queryParams = [];
    
    // Only include relevant properties that should appear in the URL
    const includedProps = ['size', 'page', 'searchText', 'status'];
    
    // Add each valid property to the queryParams array
    for (const prop of includedProps) {
      if (paginationParams[prop] !== undefined && 
          paginationParams[prop] !== null && 
          paginationParams[prop] !== '') {
            if (prop === 'status') {
                queryParams.push(`${prop}=${encodeURIComponent(paginationParams[prop].toLowerCase())}`);
              } else {
                queryParams.push(`${prop}=${encodeURIComponent(paginationParams[prop])}`);
        }
      }
    }
    
    // Join all parameters with "&" and prefix with "?"
    return queryParams.length ? `?${queryParams.join('&')}` : '';
  }


// WEBPACK FOOTER //
// ./src/store/modules/receipts/actions.js